import React from 'react';
import { Section } from './ui/Section';
import { Moon } from 'lucide-react';
export function OpeningHook() {
  return <Section bg="cream" className="border-b border-cream-dark" data-id="element-130">
      <div className="max-w-3xl mx-auto" data-id="element-131">
        <div className="flex justify-center mb-8" data-id="element-132">
          <div className="p-4 bg-navy/5 rounded-full" data-id="element-133">
            <Moon className="w-8 h-8 text-navy" data-id="element-134" />
          </div>
        </div>

        <div className="prose prose-lg md:prose-xl text-navy/80 mx-auto" data-id="element-135">
          <p className="italic font-serif text-2xl md:text-3xl leading-relaxed text-center mb-8 text-navy" data-id="element-136">
            "Son las 3 de la mañana. Tu cachorro no deja de aullar, tus vecinos
            están a punto de quejarse y tienes que trabajar en pocas horas."
          </p>

          <p className="mb-6" data-id="element-137">
            Te acercas a la sala y, en la oscuridad, pisas un charco tibio en tu
            alfombra favorita. En ese momento, el amor que sientes por tu
            mascota se mezcla con una frustración profunda.
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark my-10 relative" data-id="element-138">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-amber rounded-l-2xl" data-id="element-139"></div>
            <p className="text-xl font-medium text-navy m-0" data-id="element-140">
              No eres un mal dueño por sentirte así. Solo estás operando sin un
              plan de emergencia.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}